module.exports = __webpack_public_path__ + "static/media/icon-lecture.bbbd42ce.svg";